import { Dropdown, Badge } from 'components/ui'
import { AIContext } from 'contexts/AIContext'
import React, { useContext } from 'react'
import { HiChevronDown, HiStar, HiSparkles } from 'react-icons/hi'
import { BsLightning } from 'react-icons/bs'

const AIVideoDropdownModels = ({ model, setModel, className, parentClassName, showCreditsInToggle = true, truncate = false }) => {
    
    const { aiVideoModels } = useContext(AIContext);
    
    const availableModels = aiVideoModels?.filter(m => !m.disabled && !m.hidden) || [];
    const currentModel = availableModels.find(m => m.model === model) || availableModels[0];

    const Toggle = (
        <div className={`flex items-center justify-between gap-2 cursor-pointer ${className}`}>
            <div className="flex items-center gap-2">
                <img 
                    src={currentModel?.image} 
                    alt={currentModel?.driverDisplayName}
                    className="w-3.5 h-3.5 rounded"
                />
                <div className="flex flex-col items-start">
                    <div className="flex items-center gap-2">
                        <span className="font-normal">{truncate ? currentModel?.name.slice(0, 8) + '...' : currentModel?.name}</span>
                    </div>
                    {showCreditsInToggle && <span className="text-[10px] text-gray-500 -mt-0.5">{currentModel?.price} credits{currentModel?.isPricePerSecond ? '/sec' : ''}</span>}
                </div>
            </div>
            <HiChevronDown className="text-lg" />
        </div>
    );

    return (
        <div className={parentClassName}>
            <Dropdown 
                renderTitle={Toggle}
                placement="bottom-center"
                className="!w-full"
                menuClass="max-h-[250px] lg:max-h-[290px] overflow-y-auto"
            >
                {availableModels.map((modelObj) => (
                    <Dropdown.Item 
                        key={modelObj.model}
                        eventKey={modelObj.model} 
                        onSelect={() => setModel(modelObj.model)}
                        className={`flex items-center gap-3 p-3 py-2 hover:!bg-gray-100 dark:hover:!bg-gray-900/20 ${model === modelObj.model ? 'bg-purple-50 dark:bg-purple-900/20' : ''}`}
                    >
                        <img 
                            src={modelObj.image} 
                            alt={modelObj.driverDisplayName}
                            className="w-5 h-5 rounded"
                        />
                        <div className="flex-1">
                            <div className="flex items-center gap-2">
                                <div className="font-normal">{modelObj.name}</div>
                                {modelObj.best && (
                                    <div className="flex items-center gap-1">
                                        <HiStar className="w-3 h-3 text-yellow-500" />
                                    </div>
                                )}
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="text-[10px] font-normal opacity-70">{modelObj.price} credits{modelObj.isPricePerSecond ? '/sec' : ''}</span>
                            </div>
                        </div>
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </div>
    )
}

export default AIVideoDropdownModels
